export const MAX_ALLOWED_TRENDING_INDICATORS = 10;
export const MAX_ALLOWED_KEY_INDICATORS = 10;
export const MAX_ALLOWED_STATIC_INDICATORS = 10;
export const MAX_ALLOWED_FREQUENTLY_USED_INDICATORS = 10;
export const MAX_ALLOWED_WHATS_NEW = 10;
